module.exports = __webpack_public_path__ + "img/w2.278fca0f.png";